export const FLASH_MESSAGE = {
  wopt: 'wopt',
  sopt: 'sopt',
  'vrm-signup': 'vrm-signup',
  'vrm-signout': 'vrm-signout',
};
